// ----------------------------------------------------------------------
// <copyright file="Izenda.NotificationBoard.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var moment = require('moment');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var uiState = require('logic/Izenda.UiState');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var { MESSAGES_LIST, MODULES } = require('logic/data/Izenda.NotificationConstants');
  
  var { get, indexOf, toUpper, find } = require('lodash/fp');

  var NotificationBoard = React.createClass({
    getInitialState: function () {
      return {
        show: false
      }
    },

    componentDidMount: function(){
      this.props.store.getNotificationInterval()
      .then(result => {
        if(result.success){
          const interval = result.data;
          const loadAllNotifications = () => {
            uiState.setUpdateNotifications();
            setTimeout(loadAllNotifications, interval * 1000);
          }
          loadAllNotifications();
        }
      });
    },

    registerNotificationBoardElement: function(element){
      this.notificationBoardElement = element;
    },

    render: function () {
      var numberOfMessage = uiState.unReadNotificationsCount;
      var isShowBadge = numberOfMessage > 0;

      return (
        <div className="izenda-NotificationBoard u-posRelative">
          <span onClick={this.toggleNotification} className='icon-alert' />
          {isShowBadge && <span className="badge u-posAbsolute u-bgRed">{numberOfMessage}</span>}
          {this.state.show && <span className="icon-filled-triangle-up u-posAbsolute u-colorWhite" />}
          {this.state.show && this.renderNotifications()}
        </div>
      )
    },
 
    renderNotifications: function () {
      var props = this.props;
      var localization = props.localization;

      var notifications = uiState.notifications;
      var isHaveMessage = notifications.length > 0;

      return (
        <div ref={this.registerNotificationBoardElement} className="izenda-NotificationBoard-Message u-posAbsolute u-bgWhite u_borderAll">
           <ScrollBox autoHeight autoHeightMax={500}>
            <div>
              <div className='u_borderBottom u_paddingAll'>
                <strong>{localization.getText('NOTIFICATION_POPUP_TITLE')}</strong>
              </div>
              {isHaveMessage && notifications.map(this.renderNotification)}
              {!isHaveMessage && (
                <div className='u_borderBottom u_paddingAll'>
                  {localization.getText('NOTIFICATION_POPUP_NO_NOTIFICATIONS_MESSAGE')}
                </div> 
              )}
            </div>
          </ScrollBox>
        </div>
      );
    },

    renderNotification: function(notification){
      var getNotificationMessage = this.getNotificationMessage;
      var getOnNotificationClickHandler = this.getOnNotificationClickHandler;

      var notificationMessageID = get('notificationMessageID', notification);
      var notificationInfo = find(el => el.id == notificationMessageID, MESSAGES_LIST);
      var notificationModule = notificationInfo.module;
      

      return (
        <div onClick={getOnNotificationClickHandler(notificationModule)} style={{'cursor': 'pointer'}} className='u_borderBottom u_paddingAll' key={notification.id}>
          <div className='u_marginBottom'>
            <strong>{notificationModule.title}</strong>
          </div>
          <div className='u_marginBottom'>{getNotificationMessage(notification, notificationInfo,this)}</div>
          <div className='align-right'>{moment.utc(notification.created).fromNow()}</div>
        </div>
      )
    },

    getOnNotificationClickHandler: function (notificationModule) {
      const { router } = this.props;

      function onExportNotificationClick() {
        var myProfileUrl = routeUtils.getMyProfileUrl();
        uiState.setOpenExportManagerStatus(true);
        if (!router.isActive(myProfileUrl)) {
          this.closeNotification();
          router.push(myProfileUrl);
        } else {
          router.go(myProfileUrl);
        }
      }

      function notImplemented() {}

      switch(notificationModule.value){
        case MODULES.EXPORT_QUEUE.value:
          return onExportNotificationClick.bind(this);
        default:
          return notImplemented;
      }
    },
   
    getNotificationMessage: function (notification, notificationInfo) {
      const {renderNotificationLink} = this.props;
      var notificationTemplate = notificationInfo.template;
      var notificationModule = notificationInfo.module;

      function getExportQueueNotificationMessage(){
        var replaceValuesSeparatorIndex = indexOf(',', notification.replaceValues);
        var format = toUpper(notification.replaceValues.slice(0, replaceValuesSeparatorIndex));
        var name = notification.replaceValues.slice(replaceValuesSeparatorIndex + 1);

        return String.format(notificationTemplate, format, name);
      }

      function getProvisionMapNotificationMessage(){
        return notificationTemplate;
      }

      function getResetNLQNotificationMessage(){
        return notificationTemplate;
      }

      function getConfigureNLQNotificationMessage(){
        return notificationTemplate;
      }

      function getSaveNLQReportNotificationMessage(){

      var replaceNotificationMessages = notification.replaceValues.split(',');

        return (
          <div>
           {renderNotificationLink(replaceNotificationMessages[0],replaceNotificationMessages[1],replaceNotificationMessages[2])}
           {notificationTemplate}
          </div>        
          );
      }
      function getSaveNLQDashboardNotificationMessage(){
        var replaceNotificationMessages = notification.replaceValues.split(',');
  
          return (
            <div>
             {renderNotificationLink(replaceNotificationMessages[0],replaceNotificationMessages[1],replaceNotificationMessages[2])}
             {notificationTemplate}
            </div>        
            );
        }

      switch(notificationModule.value){
        case MODULES.EXPORT_QUEUE.value:
          return getExportQueueNotificationMessage();
        case MODULES.PROVISION_MAP.value:
          return getProvisionMapNotificationMessage();
        case MODULES.RESET_NLQ.value:
          return getResetNLQNotificationMessage();
        case MODULES.SAVE_NLQ_REPORT.value:
          return getSaveNLQReportNotificationMessage();
        case MODULES.SAVE_NLQ_DASHBOARD.value:
          return getSaveNLQDashboardNotificationMessage();
        case MODULES.CONFIGRE_NLQ.value:
          return getConfigureNLQNotificationMessage();
      }
    },

    closeNotification: function() {
      document.removeEventListener('click', this.clickListener);
      this.setState({
        show: false
      });
    },

    toggleNotification: function () {
      var newState = !this.state.show;
      
      if(newState){
        var props = this.props;
        var store = props.store;

        this.setState({
          show: newState
        });

        store.markNotificationsAsRead().then(() => {
          uiState.unReadNotificationsCount = 0;
        });

        this.clickListener = (event) => {
          var notificationBoardElement = this.notificationBoardElement;
          if(notificationBoardElement){
            if(!$izenda.contains(notificationBoardElement, event.target)){
              this.closeNotification();
            }
          }
        }
        document.addEventListener('click', this.clickListener);
      }
    }

  });

  module.exports = connect()(NotificationBoard);

}());


// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.NotificationBoard.jsx